import Icon from "@mdi/react";
import { useTheme } from "@mui/material";
import { IconProps } from "@mdi/react/dist/IconProps";

export interface ContrastIconProps extends IconProps {
  color?: string;
}

function ContrastIcon(props: ContrastIconProps) {
  const { color, ...rest } = props;
  const theme = useTheme();

  return <Icon color={color || theme.palette.getContrastText(theme.palette.primary.main)} {...rest} />;
}

export default ContrastIcon;
